"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAnalyticsIdMsg = void 0;
const router_1 = require("@keplr-wallet/router");
const constants_1 = require("./constants");
class GetAnalyticsIdMsg extends router_1.Message {
    static type() {
        return "get-analytics-id";
    }
    constructor() {
        super();
    }
    validateBasic() {
        // noop
    }
    approveExternal() {
        return true;
    }
    route() {
        return constants_1.ROUTE;
    }
    type() {
        return GetAnalyticsIdMsg.type();
    }
}
exports.GetAnalyticsIdMsg = GetAnalyticsIdMsg;
//# sourceMappingURL=messages.js.map